<template>
  <LoadingButton
    v-bind="$attrs"
    v-on="$listeners"
    @click="onClick"
    :busy="busy"
    :disabled="disabled || busy"
  >
    <slot/>
  </LoadingButton>
</template>

<script>
export default {
  name: 'LoadingButtonAction',
  inheritAttrs: false,
  props: {
    name: String,
    message: String,
    confirmFn: Function,
    clickFn: Function,
    disabled: Boolean,
  },
  data() {
    return {
      busy: false,
    }
  },
  watch: {
    busy: {
      handler(val) { this.$emit('update:busy', val) },
      immediate: true,
    },
  },
  destroyed() {
    if (this.busy) { this.$emit('update:busy', false) }
  },
  methods: {
    async onClick() {
      // workaround for stuck tooltips https://github.com/bootstrap-vue/bootstrap-vue/issues/6540
      if (this.$el.attributes['aria-describedby']) {
        this.$root.$emit('bv::hide::tooltip')
      }
      if (this.confirmFn && !(await this.confirmFn())) { return }
      this.busy = true
      // show spinner even if clickFn is heavy
      await new Promise(resolve => setTimeout(resolve, 15))

      const result = await this.clickFn()
        .finally(() => this.busy = false)
      this.$emit('success', result)
      this.$root.$bvToast.toast(this.message, {title: this.name, variant: 'success'})
    },
  },
}
</script>
